import { useEffect, useRef } from "react";
import { usePendientesImpresionLocal, useConfirmarImpresionLocal } from "@/lib/queries/impresion";
import { imprimirTicketWindows } from "@/lib/impresionWindows";

/**
 * Componente sin interfaz visible: mientras esté montado (una sola vez, en
 * App.tsx, fuera de las rutas), sondea comandas pendientes asignadas a
 * impresoras SISTEMA_LOCAL (USB/driver de Windows, sin IP de red — el
 * backend no puede hablarles por TCP) y las imprime con window.print() en
 * ESTE dispositivo. Solo tiene efecto real en el PC/tablet que de verdad
 * tiene esa impresora conectada; en los demás simplemente no encuentra
 * nada que imprimir.
 */
export default function ImpresionLocalWatcher() {
  const { data: pendientes } = usePendientesImpresionLocal();
  const confirmar = useConfirmarImpresionLocal();
  const enProceso = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!pendientes || pendientes.length === 0) return;

    for (const job of pendientes) {
      if (enProceso.current.has(job.id)) continue;
      enProceso.current.add(job.id);

      imprimirTicketWindows({
        titulo: job.ticket.titulo,
        subtitulo: job.ticket.subtitulo,
        mesaNumero: job.ticket.mesaNumero,
        meseraNombre: job.ticket.meseraNombre,
        fecha: job.ticket.fecha ? new Date(job.ticket.fecha) : undefined,
        items: job.ticket.items,
        total: job.ticket.total,
        notasGenerales: job.ticket.notasGenerales,
      });

      confirmar.mutate(job.id, {
        onSettled: () => enProceso.current.delete(job.id),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendientes]);

  return null;
}
